import { alpha } from "@mui/material/styles";

const GREY = {
  50: "#F9FAFB",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

const PRIMARY = {
  lighter: "#EAF1FB",
  light: "#AEC5E6",
  main: "#0F2D5C",
  dark: "#0C2449",
  darker: "#091B37",
  darkest: "#061530",
  contrastText: "#FFFFFF",
};

const SECONDARY = {
  lighter: "#E6F7FF",
  light: "#4DC8FE",
  main: "#02B2FE",
  dark: "#2196F3",
  contrastText: "#FFFFFF",
};

const CARD_ONE = {
  main: "#D6E2F3",
  contrastText: PRIMARY.main,
};

const ICON_ONE = {
  main: SECONDARY.light,
  contrastText: SECONDARY.main,
};

const GREEN = {
  main: "#4DC369",
  contrastText: "#fff",
};

const INFO = {
  lighter: "#D0F2FF",
  light: "#74CAFF",
  main: SECONDARY.main,
  dark: SECONDARY.dark,
  darker: "#0D47A1",
  contrastText: "#fff",
};

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#54D62C",
  dark: "#229A16",
  darker: "#08660D",
  contrastText: GREY[800],
};

const WARNING = {
  lighter: "#FFF7CD",
  light: "#FFE16A",
  main: "#FFC107",
  dark: "#B78103",
  darker: "#7A4F01",
  contrastText: GREY[800],
};

const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF4842",
  dark: "#B72136",
  darker: "#7A0C2E",
  contrastText: "#fff",
};

const palette = {
  common: { black: "#000", white: "#fff" },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  green: GREEN,
  card_one: CARD_ONE,
  icon_one: ICON_ONE,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#fff",
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(SECONDARY.main, 0.08),
    selected: alpha(SECONDARY.main, 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(SECONDARY.main, 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
